//
//
//
//
//
//
//
//
//
//
//
//
//

import List from "@/components/RegionAccount/List";
export default {
  name: "CountyManageList",
  components: { List },
  data() {
    return {
      accountType: "county",
    };
  },
};
